module.exports = __webpack_public_path__ + "static/media/brand-icons.13db00b7.eot";